import { defineCustomElements } from '@ionic/pwa-elements/loader'
defineCustomElements(window).then()
